
import { css } from 'lit';
export default css`
:host{
  --basic-hero-left-width:40%;
  --basic-hero-right-width:60%;
  --basic-hero-text-color:var(--primary-eggplant);
  --basic-hero-background-color:var(--primary-white);
  display:block;
}

  :host pc-animation{
    position:absolute;
    width:100%;
    bottom:min(33%, 160px);
    right:0;
    left:53%;
    height:100%;
    display:none;
    transition:all ease-in-out 0.3s;
  }

  @media (min-width: 320px){

  :host pc-animation{
      display:block
  }
    }

  @media (min-width: 640px){

  :host pc-animation{
      left:37%;
      bottom:min(27%, 120px)
  }
    }

  @media (min-width: 768px){

  :host pc-animation{
      left:27%;
      bottom:min(25%, 85px)
  }
    }

  @media (min-width: 992px){

  :host pc-animation{
      left:55%;
      bottom:min(2%, 25px);
      min-height:250px
  }
    }

  @media (min-width: 1440px){

  :host pc-animation{
      left:30%;
      bottom:min(2%, 25px)
  }
    }

  @media (min-width: 1920px){

  :host pc-animation{
      width:unset;
      left:unset;
      bottom:0
  }
    }

  :host .basic-hero{
  position:relative;
  overflow:hidden;
  background-color:var(--basic-hero-background-color);
}

  :host .left-side{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-8);
  padding-top:var(--spacing-8);
  padding-bottom:var(--spacing-8);
  color:var(--basic-hero-text-color);
  z-index:1;
  transition:opacity 1s ease-in-out;
  opacity:0;
}

  :host .content{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
  max-width:550px;
  transform:translateY(10px);
  transition:all ease-in-out .6s;
}

  @media (min-width: 992px){
  :host pc-container{
    display:grid;
    grid-template-columns:var(--basic-hero-left-width) var(
        --basic-hero-right-width
      );
  }

  :host .left-side{
    gap:var(--spacing-16);
  }

  :host .content{
    max-width:515px;
  }

  :host .right-side{
    display:flex;
    flex-direction:column;
    align-items:end;
    padding-top:var(--spacing-16);
    padding-bottom:var(--spacing-8);
    position:relative;
  }

  }

:host([loaded]) .left-side{
    opacity:1;
  }

:host([loaded]) .content{
    transform:translateY(0px);
  }
`;